import i18n from '~/common/i18n'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(i18n)
})
